module.exports = __webpack_public_path__ + "540d67563033b9d50ffc2361d3a30cf7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/drums/6_F2.mp3
// module id = 63
// module chunks = 0